import React, { FC, useContext, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import RoutesComponentProps from "./RoutesComponentProps";
import UserEntity from "../../../domain/entities/UserEntity";
import HomePage from "../pages/home/HomePage";
import LoadUseCase, { LoadUseCaseName } from "../../../domain/use_cases/default/LoadUseCase";
import LoadingComponent from "../components/LoadingComponent/LoadingComponent";
import di from "../../../di/DependencyInjection";
import CatalogoPage from "../pages/car/catalogo/CatalogoPage";
import {
    CATALOGO_CAMIONES,
    CATALOGO_CARROS,
    CATALOGO_INDRIVE,
    CATALOGO_MOTOS,
    CATALOGO_VANS,
} from "../pages/car/catalogo/catalogos";
import DetailedCarPage from "../pages/car/detailedCar/DetailedCarPage";
import ReportePeritajePage from "../pages/car/reportePeritaje/ReportePeritajePage";
import BookACarPage from "../pages/car/bookACar/BookACarPage";
import BookADatePage from "../pages/car/bookADate/BookADatePage";
import SellYourCarPage from "../pages/car/sellYourCar/SellYourCarPage";
import QuoteYourCarPage from "../pages/sell/quote/QuoteYourCarPage";
import QuoteSuccessfulPage from "../pages/sell/sucessfullQuote/QuoteSuccessfulPage";
import AboutUsPage from "../pages/aboutUs/AboutUsPage";
import ServicesPage from "../pages/services/debt/ServicesPage";
import ProceduresPage from "../pages/services/procedures/ProceduresPage";
import InsurancePage from "../pages/services/insurances/InsurancePage";
import BlogPage from "../pages/blog/home/BlogPage";
import BlogDetailedPage from "../pages/blog/detailed/BlogDetailedPage";
import ContactPage from "../pages/contact/ContactPage";
import SignUpPage from "../pages/auth/signUp/SignUpPage";
import SignInPage from "../pages/auth/signIn/SignInPage";
import SendRecoveryCodePage from "../pages/auth/sendRecoveryCode/SendRecoveryCodePage";
import CheckRecoveryCodePage from "../pages/auth/checkRecoveryCode/CheckRecoveryCodePage";
import Error404Page from "../pages/error404/Error404Page";
import GeneralPoliciesPage from "../pages/policies/GeneralPoliciesPage";
import CarForAllPoliciesPage from "../pages/policies/CarForAllPoliciesPage";
import SellerPoliciesPage from "../pages/policies/SellerPoliciesPage";
import BuyerPolicies from "../pages/policies/BuyerPolicies";
import SuccesfulPaymentPage from "../pages/succesfulPayment/SuccesfulPaymentPage";
import BuyOrSellPage from "../pages/landings/buyOrSellPage/BuyOrSellPage";
import { Helmet } from "react-helmet-async";
import SaleYourCarPage from "../pages/policies/SaleYourCarPage";
import DontButNewCarBuyAUsed from "../pages/redirect/DontButNewCarBuyAUsed";
import TermAndConditionsUser from "../pages/policies/TermAndConditionsUser";
import TermAndConditionsSalseYesOrYes from "../pages/policies/TermAndConditionsSalesYesOrYes";
import TermAndConditionsNewUsed6MonthWarrany from "../pages/policies/TermAndConditionsNewUsed6MonthWarrany";
import TermAndConditionsNewUsed6MonthWarrany2 from "../pages/policies/TermAndConditionsNewUsed6MonthWarrany2";
// import TermAndConditions from "../pages/policies/termAndConditions";
import PrivacyPoliciesForMobileApp from "../pages/policies/PrivacyPoliciesForMobileApp";
import DataPrivacyNoticeForWcarAppUsers from "../pages/policies/DataPrivacyNoticeForWcarAppUsers";
import PrivacyPolicies from "../pages/policies/privacyPolicies";
import HomePage1 from "../pages/home-1/HomePage";
import DeleteAccountPage from "../pages/deleteAccount/deleteAccountPage";
import TermAndConditions from "../pages/termAndConditions/termAndConditions";
import ThankyouPage from "../pages/Thankyou/ThankyoutPage";
import CampaignPage from "../pages/campaign/campaign";
// import { WorkshopAndService } from "../pages/workshopAndService/workshopAndService";
import TallerPage from "../pages/services/taller/TallerPage";
import { WorkshopAndService } from "../pages/workshopAndService/workshopAndService";
import NewInsurancePage from "../pages/services/newInsurances/newInsurancePage";
import { BlackFriday } from "../pages/blackfriday/blackFriday";
import DetailedCarUserPage from "../pages/car/detailedCarUser/DetailedCarPage";
import MyCarsUserPage from "../pages/car/MyCarsUser/BuyYourCarPage";
import LinktreePage from "../pages/linktree/Linktree";
import BookADatePageSale from "../pages/car/bookADate/BookADatePageSale";
import DetailUserPage from "../pages/car/DetailUser/DetailUserPage";
import FavoritesPage from "../pages/car/favorites/FavoritesPage";
import FavoriteCarsContext from "../../../domain/providers/favoriteCars/FavoriteCarsContext";
import GetFavoriteCarsUseCase, { GetFavoriteCarsUseCaseName } from "../../../domain/use_cases/car/GetFavoriteCarsUseCase";
import EditProfilePage from "../pages/car/EditProfile/EditProfilePage";
import ContactPageDetail from "../pages/contact/ContactPageDetail";
import NewInsurancePageDetail from "../pages/services/newInsurances/newInsurancePageVehicles";
import UserContext from "../../../domain/providers/user/UserContext";
import HeadquartersPage from "../pages/services/headquarters/headquartersPage";
import LadingPage from "../pages/car/landingPage/landingPage";
import CheckoutQrScreen from "../pages/checkoutQrScreen/CheckoutQrScreen";
import Landingcomfacundi from "../pages/comcafundi/Comcafundi";
import PeritajeAutomasDemoPage from "../pages/car/peritajeAutomas/PeritajeAutomasDemoPage";
import { ExternalRedirect } from "./ExternalRedicrect";
import { IS_SCREENS_MODE } from "../../../config/appMode";

// Las cuatro rutas de catálogo son la misma página con distinta configuración.
// `routes` monta los componentes sin props, así que cada una se ata aquí.
const BuyYourCarPage: FC = () => <CatalogoPage config={CATALOGO_CARROS} />;
const BuyYourCarInDrivePage: FC = () => <CatalogoPage config={CATALOGO_INDRIVE} />;
const BuyYourMotorCyclePage: FC = () => <CatalogoPage config={CATALOGO_MOTOS} />;
const BuyYourTruckPage: FC = () => <CatalogoPage config={CATALOGO_CAMIONES} />;
const BuyYourvansPage: FC = () => <CatalogoPage config={CATALOGO_VANS} />;

export interface iRoute {
    name: string;
    path: string;
    relativePath: string;
    component: FC;
    auth: (user: UserEntity | undefined) => boolean;
}

export interface iRouteModule {
    page: iRoute;
    pages: iRoute[];
}

const routes = {
    error_404: {
        name: "Error 404",
        path: "/error/404",
        relativePath: "/error/404",
        component: Error404Page,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    home: {
        path: "/",
        relativePath: "/",
        component: HomePage,
        helmet: null,
        auth: (user: UserEntity | undefined) => true,
    },
    // taller: {
    //     path: "/taller",
    //     relativePath: "/taller",
    //     component: TallerPage,
    //     helmet: null,
    //     auth: (user: UserEntity | undefined) => true,
    // },
    // home1: {
    //     path: "/home",
    //     relativePath: "/home",
    //     component: HomePage1,
    //     helmet: null,
    //     auth: (user: UserEntity | undefined) => true,
    // },
    buyYourCar: {
        path: "/compra-tu-carro/:typeVehicleName?",
        relativePath: "/compra-tu-carro",
        component: BuyYourCarPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    buyYourCarInDrive: {
        path: "/compra-tu-carro/indrive",
        relativePath: "/compra-tu-carro/indrive",
        component: BuyYourCarInDrivePage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    detailedCarInDrive: {
        path: "/compra-tu-carro/indrive/:typeVehicle/:nameVehicle/:id",
        relativePath: "/compra-tu-carro/indrive",
        component: DetailedCarPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    landingPage: {
        path: "/carros-usados-de-alta-gama-listos-para-ti",
        relativePath: "/carros-usados-de-alta-gama-listos-para-ti",
        component: LadingPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    buyYourMotorcycle: {
        path: "/compra-tu-moto/:typeVehicleName?",
        relativePath: "/compra-tu-moto",
        component: BuyYourMotorCyclePage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    buyYourVan: {
        path: "/compra-tu-van/:typeVehicleName?",
        relativePath: "/compra-tu-van",
        component: BuyYourvansPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    buyYourTruck: {
        path: "/compra-tu-camion/:typeVehicleName?",
        relativePath: "/compra-tu-camion",
        component: BuyYourTruckPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    myCarsUserPage: {
        path: "/tus-vehiculos",
        relativePath: "/tus-vehiculos",
        component: MyCarsUserPage,
        auth: (user: UserEntity) => false,
        helmet: null,
    },
    favorites: {
        name: "Favoritos",
        path: "/favoritos",
        relativePath: "/favoritos",
        component: FavoritesPage,
        auth: (user: UserEntity | undefined) => !!user,
        helmet: null,
    },
    detailUser: {
        path: "/perfil",
        relativePath: "/perfil",
        component: DetailUserPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    buyYourCarUsedTrucks: {
        path: "/compra-tu-carro/camionetas-usadas",
        relativePath: "/compra-tu-carro/camionetas-usadas",
        component: BuyYourCarPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    reportePeritaje: {
        path: "/reporte-peritaje",
        relativePath: "/reporte-peritaje",
        component: ReportePeritajePage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    detailedCar: {
        path: "/compra-tu-carro/:typeVehicle/:nameVehicle/:id",
        relativePath: "/compra-tu-carro",
        component: DetailedCarPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    editUser: {
        path: "/editar-usuario",
        relativePath: "/editar-usuario",
        component: EditProfilePage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    detailedCarUser: {
        path: "/tus-vehiculos/:id",
        relativePath: "/tus-vehiculos",
        component: DetailedCarUserPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    detailedCarRelated: {
        path: "/compra-tu-carro/relacionado/:typeVehicle/:nameVehicle/:id",
        relativePath: "/compra-tu-carro/relacionado",
        component: DetailedCarPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    bookCar: {
        path: "/carro/separar/:id",
        relativePath: "/carro/separar",
        component: BookACarPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    dateForCar: {
        path: "/carro/cita/:action/:carId",
        relativePath: "/carro/cita",
        component: BookADatePage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    dateForSell: {
        path: "/:action/cita/",
        relativePath: "/vender/cita",
        component: BookADatePageSale,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    sellYourCar: {
        path: "/vende-tu-carro",
        relativePath: "/vende-tu-carro",
        component: SellYourCarPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    quoteYourCar: {
        path: "/cotizar",
        relativePath: "/cotizar",
        component: QuoteYourCarPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    quoteSuccessful: {
        path: "/cotizar/resultado",
        relativePath: "/cotizar/resultado",
        component: QuoteSuccessfulPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    aboutUs: {
        path: "/nuestra-empresa",
        relativePath: "/nuestra-empresa",
        component: AboutUsPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    services: {
        path: "/financiacion",
        relativePath: "/financiacion",
        component: ServicesPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    contact: {
        path: "/contacto",
        relativePath: "/contacto",
        component: ContactPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    contactDetail: {
        path: "/contacta-a-la-empresa",
        relativePath: "/contacta-a-la-empresa",
        component: ContactPageDetail,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    campaignPage: {
        path: "/compra-o-vende-tu-auto-usado-hoy",
        relativePath: "/compra-o-vende-tu-auto-usado-hoy",
        component: CampaignPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    deleteAccount: {
        path: "/eliminacion-de-cuenta",
        relativePath: "/eliminacion-de-cuenta",
        component: DeleteAccountPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    procedures: {
        path: "/tramites-de-vehiculos",
        relativePath: "/tramites-de-vehiculos",
        component: ProceduresPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    insurance: {
        path: "/seguro-todo-riesgo",
        relativePath: "https://wcarseguros.com/",
        // Pasamos el componente y le inyectamos la URL externa
        component: () => <ExternalRedirect url="https://wcarseguros.com/" />,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },

    insuranceVehicles: {
        path: "/seguro-todo-riesgo-vehiculos/:insuranceId",
        relativePath: "/seguro-todo-riesgo-vehiculos/:insuranceId",
        // component: InsurancePage,

        component: NewInsurancePageDetail,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },

    headquarter: {
        path: "/nuestras-sedes",
        relativePath: "/nuestras-sedes",
        // component: InsurancePage,

        component: HeadquartersPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    blog: {
        path: "/blog",
        relativePath: "/blog",
        component: BlogPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    detailedBlog: {
        path: "/blog/:id",
        relativePath: "/blog",
        component: BlogDetailedPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    signIn: {
        path: "/iniciar-sesion",
        relativePath: "/iniciar-sesion",
        component: SignInPage,
        auth: (user: UserEntity | undefined) => user == undefined,
        helmet: null,
    },
    signUp: {
        path: "/registrarse",
        relativePath: "/registrarse",
        component: SignUpPage,
        auth: (user: UserEntity | undefined) => user == undefined,
        helmet: null,
    },
    sendRecoveryCode: {
        path: "/recuperar-contraseña",
        relativePath: "/recuperar-contraseña",
        component: SendRecoveryCodePage,
        auth: (user: UserEntity | undefined) => user == undefined,
        helmet: null,
    },
    updatePasswordRecovery: {
        path: "/recuperar-contrasena-app/:email",
        relativePath: "/recuperar-contrasena-app",
        component: CheckRecoveryCodePage,
        auth: (user: UserEntity | undefined) => user == undefined,
        helmet: null,
    },
    generalPolicies: {
        path: "/politica-de-privacidad",
        relativePath: "/politica-de-privacidad",
        component: GeneralPoliciesPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    termAndConditionsUser: {
        path: "/terminos-y-condiciones-usuarios",
        relativePath: "/terminos-y-condiciones-usuarios",
        component: TermAndConditionsUser,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    // termAndConditionsSalesYesOrYes: {
    //     path: "/vende-tu-carro-si-o-si",
    //     relativePath: "/vende-tu-carro-si-o-si",
    //     component: TermAndConditionsSalseYesOrYes,
    //     auth: (user: UserEntity | undefined) => true,
    //     helmet: null,
    // },
    termAndConditionsNewUsed6MonthWarrany: {
        path: "/tu-nuevo-usado-en-wcar-con-garantica-de-6-meses",
        relativePath: "/tu-nuevo-usado-en-wcar-con-garantica-de-6-meses",
        component: TermAndConditionsNewUsed6MonthWarrany,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    termAndConditionsNewUsed6MonthWarrany2: {
        path: "/tu-nuevo-usado-en-wcar-con-garantica-de-6-meses2",
        relativePath: "/tu-nuevo-usado-en-wcar-con-garantica-de-6-meses2",
        component: TermAndConditionsNewUsed6MonthWarrany2,
    },
    // termAndConditions: {
    //     path: "/terminos-y-condiciones-garantia",
    //     relativePath: "/terminos-y-condiciones-garantia",
    //     component: TermAndConditions,
    //     auth: (user: UserEntity | undefined) => true,
    //     helmet: null,
    // },
    privacyPolicies: {
        path: "/politicas-de-privacidad-para-la-aplicacion-movil-wcar",
        relativePath: "/politicas-de-privacidad-para-la-aplicacion-movil-wcar",
        component: PrivacyPolicies,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    // privacyPolicyMobileApp: {
    //     path: "/politicas-de-privacidad-para-la-aplicacion-movil-wcar",
    //     relativePath: "/politicas-de-privacidad-para-la-aplicacion-movil-wcar",
    //     component: PrivacyPoliciesForMobileApp,
    //     auth: (user: UserEntity | undefined) => true,
    //     helmet: null,
    // },
    dataPrivacyNoticeWcarAppUsers: {
        path: "/aviso-de-privacidad-de-datos-para-usuarios-app-wcar",
        relativePath: "/aviso-de-privacidad-de-datos-para-usuarios-app-wcar",
        component: DataPrivacyNoticeForWcarAppUsers,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    carForAllPolicies: {
        path: "/auto-para-todos-beneficios-unicos",
        relativePath: "/auto-para-todos-beneficios-unicos",
        component: CarForAllPoliciesPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    saleYourCar: {
        path: "/vende-tu-auto-sin-tanto-rollo",
        relativePath: "/vende-tu-auto-sin-tanto-rollo",
        component: SaleYourCarPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    sellerPolicies: {
        path: "/politicas-vendedor",
        relativePath: "/politicas-vendedor",
        component: SellerPoliciesPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    buyerPolicies: {
        path: "/politicas-comprador",
        relativePath: "/politicas-comprador",
        component: BuyerPolicies,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    succesfulPayment: {
        path: "/pago-exitoso/:bookingId",
        relativePath: "/pago-exitoso",
        component: SuccesfulPaymentPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    buyOrSell: {
        path: "/compra-o-vende-tu-carro-en-colombia",
        relativePath: "/compra-o-vende-tu-carro-en-colombia",
        component: BuyOrSellPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    dontBuyNewCarBuyAUsed: {
        path: "/no-compres-auto-nuevo-elige-un-usado",
        relativePath: "/no-compres-auto-nuevo-elige-un-usado",
        component: DontButNewCarBuyAUsed,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    termAndConditions: {
        path: "/:title/:id",
        relativePath: "/",
        component: TermAndConditions,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },

    thankyou: {
        path: "/thankyou",
        relativePath: "/thankyou",
        component: ThankyouPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    workshopAndService: {
        path: "/taller",
        relativePath: "/taller",
        component: WorkshopAndService,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },

    // blackFriday: {
    //     path: "/blackfriday-de-autos",
    //     relativePath: "/blackfriday-de-autos",
    //     component: BlackFriday,
    //     auth: (user: UserEntity | undefined) => true,
    //     helmet: null,
    // },
    linktree: {
        path: "/linktree",
        relativePath: "/linktree",
        component: LinktreePage,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    checkoutScreen: {
        path: "/checkout-screen/:id",
        relativePath: "/checkout-screen",
        component: CheckoutQrScreen,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
        screensOnly: true,
    },
    comfacundi: {
        path: "/comfacundi",
        relativePath: "/comfacundi",
        component: Landingcomfacundi,
        auth: (user: UserEntity | undefined) => true,
        helmet: null,
    },
    // Pantalla de prueba del certificado de peritaje de Automás. Temporal: existe para revisar
    // el diseño mientras se define en qué casos reales se muestra el peritaje.
    peritajeAutomasDemo: {
        path: "/peritaje-automas/:plate?",
        relativePath: "/peritaje-automas",
        component: PeritajeAutomasDemoPage,
        auth: (user: UserEntity | undefined) => true,
        helmet: (
            <>
                <title>Certificado de peritaje Automás</title>
                <meta name="robots" content="noindex, nofollow" />
            </>
        ),
    },
};

const RoutesComponent: React.FC<RoutesComponentProps> = ({ children }) => {
    const { user } = useContext(UserContext);
    const { setFavoriteCars } = useContext(FavoriteCarsContext);

    // Los favoritos son del usuario: se cargan al iniciar sesión y se vacían al cerrarla.
    useEffect(() => {
        if (user) di.get<GetFavoriteCarsUseCase>(GetFavoriteCarsUseCaseName).call();
        else setFavoriteCars([]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user?.id]);
    // const [loaded, setLoaded] = useState<boolean>(false);

    const _load = async () => {
        // if (loaded) return;
        try {
            await di.get<LoadUseCase>(LoadUseCaseName).call();
        } catch (_) {}
        // setLoaded(true);
    };
    useEffect(() => {
        _load();
    }, []);

    // if (!loaded)
    //     return (
    //         <div className="bg_1 d-flex justify-content-center" style={{ width: "100vw", height: "100vh" }}>
    //             <LoadingComponent showLogo />
    //         </div>
    //     );
    return (
        <>
            <BrowserRouter>
                <Routes>
                    {Object.values(routes)
                        .filter((route: any) => IS_SCREENS_MODE || !route.screensOnly)
                        .map((route: any) => (
                        <Route
                            key={route.path}
                            path={route.path}
                            element={
                                <>
                                    <Helmet>
                                        {route.helmet != null ? (
                                            route.helmet
                                        ) : (
                                            <>
                                                <title>wcar #1 Más que vender te aconsejamos</title>
                                                <meta
                                                    name="description"
                                                    content="¡WCAR - tu mejor opción para comprar y vender carros usados! Conocemos el mercado y te asesoramos para que encuentres el auto perfecto. ¡Contáctanos ahora!"
                                                />
                                            </>
                                        )}
                                    </Helmet>
                                    {React.createElement(route.component)}
                                </>
                            }
                        ></Route>
                    ))}
                    <Route path="*" element={<Error404Page />} />
                </Routes>
            </BrowserRouter>
        </>
    );
};

export default RoutesComponent;
export { routes, RoutesComponent };
